import { render, staticRenderFns } from "./phone-record.vue?vue&type=template&id=18e41e12&scoped=true"
import script from "./phone-record.vue?vue&type=script&lang=js"
export * from "./phone-record.vue?vue&type=script&lang=js"
import style0 from "./phone-record.vue?vue&type=style&index=0&id=18e41e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e41e12",
  null
  
)

export default component.exports